export default __webpack_public_path__ + "img/right-arrow.5e703929.svg";